
<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-xs" v-if="!insideModal">
            <div v-if="name === 'btPesquisar'" class="crud-title">
              <translate>SEARCH_RECORDS</translate>
            </div>
            <div v-else-if="name === 'btNovo'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div
              v-else-if="forms[0].nmInterface.indexOf('.alterar') > 0"
              class="crud-title"
            >
              <translate>UPDATE_REGISTRATION</translate>
            </div>
            <div v-else-if="labelPage" class="crud-title">
              {{ labelPage }}
            </div>
          </q-card-section>
          <q-card-section class="q-px-md">
            <jt-dynamic-form
              v-if="forms[0].inputs.length > 0"
              ref="jtDynamicForm"
              :inputs="forms[0].inputs"
              :interface="forms[0].nmInterface"
              :relacionamentos="forms[0].relacionamentos"
              :model="forms[0].dadosForm"
              form-class="form"
              @form-button-click="onFormButtonClick"
            />

            <div class="tw--mt-80 tw-pb-4 tw-flex tw-w-full tw-justify-end">
                <q-btn
                  icon="mdi-database-search"
                  color="secondary"
                  @click="getDataCheckCoverage()"
                >
                  {{ $gettext("CHECK_COVERAGE") }}
                </q-btn>
            </div>
            <div class="tw-h-96 tw-overflow-scroll">
              <jt-data-table
                v-if="dataCheckCoverageColumns"
                noneselect
                :api-mode="false"
                class="tw-w-full"
                :data="dataCheckCoverage"
                :fields="dataCheckCoverageColumns[0].inputs[0].columns"
                :is-paginated="false"
                :title="titleTeble"
              />
            </div>
            <div class="tw-flex tw-w-full tw-justify-end tw-gap-4">
              <span>
                  {{ $gettext("TOTAL_COVERAGE") }}:
                  <strong>{{ dataCheckCoverage.length }}</strong>
              </span>
              <span>
                  {{ $gettext("TOTAL_INVOICE") }}:
                  <strong>{{ totalInvoice() }}</strong>
              </span>
              <span>
                  {{ $gettext("TOTAL_VALUE") }}:
                  <strong>{{ totalValue() }}</strong>
              </span>
            </div>
          </q-card-section>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms[0] && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-py-md"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>

      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        :class="`col-lg-2 col-md-3 button-${
          button.name ? button.name.toLowerCase() : button.name
        }`"
      >
        <q-btn
          :class="`full-width button-btn-${
            button.name ? button.name.toLowerCase() : button.name
          }`"
          color="info"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
const { page, form } = JtCrud
import { repository } from 'src/jtech'
@Component({
  name: 'CampaignPageSend',
  mixins: [page],
  props: {
    forms: Object,
    params: Object
  },
  components: {
    'crud-form': form,
    JtDynamicForm
  }
})
class CampaignPageSend extends Vue {
  dataCheckCoverageColumns = {};
  dataCheckCoverage = [];

  totalInvoice () {
    return this.dataCheckCoverage.reduce((total, item) => {
      return total + item.invoices
    }, 0)
  }

  totalValue () {
    const value = this.dataCheckCoverage.reduce((total, item) => {
      return total + Number(item.value)
    }, 0)
    return this.$toLocaleStringBr(value)
  }

  async mounted () {
    this.forms[0].dadosForm.zendeskCampaing = this.params.selectedCampaign
    this.dataCheckCoverageColumns = await repository.resolveForm(
      'zendeskSendCampaing.hql.getDataCheckCoverage'
    )
  }

  async actionButton (button) {
    let params = this.getParams()
    if (button.name == 'btGravar' || button.name == 'btGravarSendCampaign') {
      button.name = 'btGravarSendCampaign'
      params = { ...this.forms[0].dadosForm, ...this.params, personIds: this.dataCheckCoverage.map((p) => { return p.personId }) }
    }

    this.$emit('action-button', button, params, this)
  }

  async getDataCheckCoverage () {
    if (this.$refs.jtDynamicForm.isValidForm()) {
      const result = await repository.resolveLogic(
        'zendeskSendCampaing.getDataCheckCoverage',
        { ...this.forms[0].dadosForm, ...this.params }
      )
      this.dataCheckCoverage = result.registros
    }
  }

  limparForm () {
    this.$refs.jtDynamicForm.resetForm()
  }
}

export default CampaignPageSend
</script>

<style lang="scss" scoped>
@import "tailwindcss/utilities";
</style>
